import React from 'react';
import { motion } from 'framer-motion';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-stage plan-grid py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-47" data-mp="ounbyzutcaqa">
      <div className="mx-auto max-w-4xl px-4" data-id="element-48" data-mp="12tn26bxz4xok">
        <div className="text-center" data-id="element-49" data-mp="xtqvg4xw6s5b">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-forestDeep sm:text-4xl" data-id="element-50" data-mp="xspghpdr9lib">
            Next Monday you can keep improvising…
          </h2>
          <p className="mt-4 font-display text-2xl font-extrabold text-earth sm:text-3xl" data-id="element-51" data-mp="17sq2jj30efq7">
            Or you can enter your classroom fully prepared starting today.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-52" data-mp="1hhhrdicrwjww">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-lg border border-line border-l-4 border-l-gold bg-white px-4 py-3 text-sm font-semibold text-ink shadow-card" data-id="element-53" data-mp="1vikfs1r8q6az" data-mpi={index}>
              <span className="font-display text-earth" aria-hidden="true" data-id="element-54" data-mp="2gc58zfm6p1ot">
                ▸
              </span>
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-55" data-mp="2l93x9hj62ef3">
          <p className="leading-relaxed text-inkSoft" data-id="element-56" data-mp="2q904dpn5ulyv">
            This teacher ready won't make you a better educator. You're already an excellent educator.
          </p>
          <p className="mt-3 text-lg font-bold text-forestDeep" data-id="element-57" data-mp="300mbb9sgtyvt">
            What this teacher ready does is give you the time and tools so that excellence shows in every single class.
          </p>
        </div>
      </div>
    </section>;
}